<template>
    <div class="row">
        <!-- Main Container End -->
        <div class="col-main col-sm-12 col-xs-12" style='layout-grid:15.6pt'>

            <div style="text-align: center;"><h3>隐私条款</h3></div>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><b><span
                style='
;'>&nbsp;</span></b></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
            >為方便用戶（以下簡稱「您」）使用本平臺服務，請您在註冊使用平臺服務前仔細閱讀並充分理解以下政策條款。後續您使用或在我們更新本私隱政策後繼續使用我們的服務時，即表示您同意本私隱政策（含更新版本）內容，並且同意我們按照本私隱政策收集、使用、保存和共享您的相關信息。</span><span
                style='
;'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;'>同時，我們深知個人信息對您的重要性，故我們將按照相關法律法規要求，採取相應的安全保護措施，盡力保護您的個人信息安全可控。（註：本隱私政策具有合同效力，請您謹慎閱讀並遵照執行。</span><span
                style='
'>）</span><span style=''></span></p>

            <p><span style='
'>&nbsp;</span></p>

            <p><span style='
'>一、定義與釋義</span><span
                style='
'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
'>1</span><span style=''>、平臺與我們：</span><span
                style='
'>&quot;</span><span style=''>平臺</span><span
                style='
'>&quot;</span><span style=''>是指我們網站</span><span
                style='
'>https://www.3dshopopee.com</span><span
                style=''>，以及我們的軟件，即</span><span><span style=''>Shopopee</span></span><span
                style='
'>網站和<span>應</span>用程序，以上均是指</span><span
                style='
'>Forest intelligent consultancy limited</span><span
                style='
'>。</span><span style=''></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;'>2</span><span
                style='
;'>、平臺服務：基於互聯網，以包含</span><span
                style='
;'>Shopopee</span><span
                style='
;'>網站所提供的商品展覽及推廣代理和相關應用程序等在內的各種形態（包括未來技術發展出現的新的服務形態）向您提供的各項互聯網服務。</span><span
                style='
;'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;'>&nbsp;</span></p>

            <p><span style='
;'>二、信息的收集與使用</span><span style='
;'></span></p>

            <p><span style='
;'>（一）、個人信息與隱私信息的收集</span><span style='
;'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;'>個人信息是指以電子或者其他方式記錄的能夠單獨或者與其他信息結合識別特定自然人身份或者反映特定自然人活動情況的各種信息。本私隱政策中涉及的個人信息包括但不限於其基本信息（個人姓名、電話號碼、電子郵箱、地址）等。</span><span
                style='
;'></span></p>

            <p style='margin-top:0cm;margin-right:0cm;margin-bottom:7.5pt;
margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:2.0;mso-pagination:
widow-orphan;mso-list:l10 level1 lfo1;background:white'><span
                style='
;'><span style='mso-list:
Ignore'>1、</span></span><span style='
mso-color-alt:windowtext;'>當您訪問我們的網站，使用我們的產品或服務，或以其他方式與我們互動時，我們將收集關於您以下類型的個人信息：</span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>1</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>您在註冊賬戶或註冊我們的產品亦或是服務時所提供的個人賬戶及資料信息，例如姓名、電子郵件、電話號碼、社交媒體連結等（統稱為</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'> &quot;</span><b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>賬戶資料</span></b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&quot;</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>）。</span><span
                style='color:#666666;
'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>2</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>您通過支持渠道所提供的信息，例如當您向我們提交問題報告或與我們的支持團隊互動時所產生的任何聯繫信息、文件或屏幕截圖等（統稱為</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'> &quot;</span><b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>支持數據</span></b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&quot;</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>）。</span><span
                style='color:#666666;
'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>3</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>您在&#35774;置&#36134;&#25143;或&#20010;人&#36164;料&#26102;，或在參與我們發給您的調查或問卷時，所設置的通信、營銷及其他偏好等（統稱為</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'> &quot;</span><b><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>偏好數據</span></b><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>&quot;</span><span style='font-family:
"微軟正黑體",sans-serif;;background:white;
mso-font-kerning:0pt;mso-bidi-language:AR'>）。</span><span
                style='
;color:#666666;'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>4</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>有關您使用或訪問我們的平台時的信息，例如您進入、通過和離開平台時的點擊流；您查看、使用或搜索產品時頁面響應的時間；下載錯誤、訪問某些頁面的時間；頁面互動的信息（包括但不限於滾動、點擊和鼠標懸停等），以及您離開頁面的瀏覽方法（統稱為</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&quot;</span><b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>使用數據</span></b><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&quot;</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>）。</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>6</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>您的麥克風語音、視頻、相冊和地理位置等權限信息。</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>2</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>、我們也可能從其他第三方來源收集到關於您的信息，包括：</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>1</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>與您的賬戶相關的其他服務，例如您授權共享的其他賬戶信息，並在您同意本隱私政策後將您的第三方賬戶與您的平台賬戶綁定，我們會將依據與第三方的約定、對個人信息來源的合法性進行確認後，在符合相關法律法規的前提下，使用您的這些個人信息。（注：第三方賬戶包括</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>WhatsApp</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>、</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>Skype</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>、</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>Facebook</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>、通訊錄等社交軟件和通訊工具）。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>（</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>2</span><span style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>）</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>.</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>我們位於香港的業務合作夥伴和服務提供商，他們在香港提供客戶支持服務（例如履行您的訂單、售前售後、物流服務、企業管理服務等）以及分析其應用程序。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-bottom:7.5pt;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-pagination:widow-orphan;background:white'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>3</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>、我們不會收集關於您的敏感數據或特殊類別數據。</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>例如您的種族、民族血統、政治、宗教、遺傳學、生物統計學、健康或性取向信息等。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-bottom:7.5pt;mso-pagination:widow-orphan;
background:white'><span style='font-family:
"微軟正黑體",sans-serif;;background:white;
mso-font-kerning:0pt;mso-bidi-language:AR'>（二）、我們如何使用所收集到的信息</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>我們會根據本隱私政策的約定並在法律法規允許的情況下，為實現我們的服務功能對所收集的個人信息進行使用。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l0 level1 lfo2'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>我們需要履行與您簽訂的（或即將簽訂的）合同，包括運營我們的產品或服務，提供客戶支持和個性化功能，並保護我們平台的安全。在收集您的個人信息後，我們將通過技術手段對數據進行標識化處理，去標識化處理的信息將無法識別主體，請您了解並同意，在此情況下我們有權使用已經去標識化的信息，並在不透露您個人信息的前提下，我們有權對用戶數據庫進行分析並予以商業化的利用。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l0 level1 lfo2'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>2、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>我們會對我們的服務使用情況進行統計，並可能會與公眾或第三方共享這些統計信息，在您的許可下，將您的信息作為我們的推薦信或客戶故事的一部分來發表，以展示我們服務的整體使用趨勢及推廣我們的平台，但這些統計信息不會包含您的任何身份識別信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l0 level1 lfo2'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>3、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>當我們要將您的個人信息用於本政策未載明的其他用途時，或基於特定目的收集而來的信息用於其他目的時，會通過您主動做出勾選的形式事先征求您的同意。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l0 level1 lfo2'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>4、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>請您注意，您在使用我們的服務時所提供的所有個人信息，除非您刪除或通過系統設置拒絕我們的收集，否則將在您使用我們的服務期間將持續授權我們使用。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>&nbsp;</span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>三、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>信息的共享、轉讓和披露</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l7 level1 lfo4'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（一）</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>、信息的共享</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l3 level1 lfo5'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>我們不會與平台運營方及其合作方以外的任何公司、組織和個人共享您的個人信息，但以下情況除外：</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（1）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>事先獲得您明確的同意或授權</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>；</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（2）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>根據適用的法律法規</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、法律程序的要求、強制性的行政或司法要求所必須的情況下進行提供；</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（3）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>在法律法規允許的範圍內</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>，為維護平台運營方及其合作方、您或平台用戶、社會公眾利益、財產或安全免遭損害而有必要提供；</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（4）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>只有共享您的信息</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>，才能實現我們的服務的核心功能或提供您所需要的服務時；</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:AR'><span
                style='mso-list:Ignore'>（5）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>基於學術研究而使用</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>；</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:AR'><span
                style='mso-list:Ignore'>（6）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>本私隱政策聲明只適用於本公司網頁及移動應用程式</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>。</span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>我們網頁及移動應用程式可能載有通往其他網址及網頁的連線點。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&nbsp;</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>每當您啟動任何此等連線網址，例如點選任何廣告客戶的連線欄目，您即已離開了我們的網址及移動應用程式；而您在離開我們網址及移動應用程式後向任何其他團體提供的任何個人資料或任何其他資料，一概不在本司的管控範圍內。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&nbsp;</span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>您須承<span
            >擔</span>一切瀏覽或使用其他網址的風險。</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l1 level1 lfo6'><span
                style='mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（7）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>我們的平台可能包含我們無法控制的第三方網站的鏈接</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>，如果您跟隨任何這些網站的鏈接，或向其提交信息，您的信息將受其政策管轄，我們也鼓勵您在向第三方網站提交信息之前，查看其私隱政策。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:21.0pt;mso-char-indent-count:
2.0;mso-list:l3 level1 lfo5'><span
                style='mso-font-kerning:0pt;mso-bidi-language:AR'><span
                style='mso-list:Ignore'>2、</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>我們可能會向合作夥伴等第三方共享您的部分信息，例如賬戶信息、設備信息以及位置信息等，以保障為您提供的服務順利完成，但我們僅會出於合法、正當、必要、特定、明確的目的共享您的個人信息，並且只會共享提供服務所必要的個人信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>我們的合作夥伴包括以下類型：</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'></span></p>

            <p style='margin-left:21.0pt;mso-para-margin-left:2.0gd;
text-indent:0cm;mso-list:l4 level1 lfo7'><span
                style='mso-font-kerning:0pt;mso-bidi-language:AR'><span
                style='mso-list:Ignore'>（1）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>產品或技術服務的供應商</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>。</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>他們提供業務相關的功能支持，例如基礎設施技術服務、物流配送服務、支付服務、數據處理等。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:21.0pt;mso-para-margin-left:2.0gd;
text-indent:0cm;mso-list:l4 level1 lfo7'><span
                style='mso-font-kerning:0pt;mso-bidi-language:AR'><span
                style='mso-list:Ignore'>（2）</span></span><span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>.</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>委託我們進行推廣的合作夥伴</span></span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>。</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>我們可能會代表其他企業向使用我們服務的用戶群提供促銷推廣的服務，但我們僅會向這些合夥夥伴提供推廣的覆蓋面和有效性信息，而不會提供您的個人身份信息，亦或是我們會將這些信息進行匯總，以便它不會識別到您個人。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l7 level1 lfo4'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（二）</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>、信息的轉讓</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>我們不會將您的個人信息轉讓給任何公司、組織和個人，但以下情況除外：</span><span style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l6 level1 lfo8'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>事先獲得您明確的同意或授權；</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l6 level1 lfo8'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>2、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>根據適用的法律法規、法律程序的要求、強制性的行政或司法要求所必須的情況下進行提供；</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l6 level1 lfo8'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>3、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>如果我們因合併、收購或業務轉讓而被第三方收購時，您的個人信息可能會因這種交易而被披露或轉讓給第三方，但我們也會要求新的持有您個人信息的公司、組織繼續受本隱私政策的約束，否則我們將要求該公司、組織重新向您征求授權同意。如果發生此類交易，我們將通知您，並告知您對您的信息可能有的選擇。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l7 level1 lfo4'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>（三）</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>、信息的披露</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>我們僅會在以下情況下，且採取符合業界標準的安全防護措施的前提下，才會公開披露您的個人信息：</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l8 level1 lfo9'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>根據您的需求，在您明確同意的披露方式下披露您所指定的個人信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l8 level1 lfo9'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>2、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>根據法律法規的要求，或是強制性的行政司法要求所必須提供您個人信息的情況下，我們可能會依據所要求的個人信息類型和披露方式進行披露。我們會對所有請求進行慎重的審查，以確保其具備合法依據，且僅限於司法、執法、或行政管理部門因特定的調查目的而有此要求。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt'><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>&nbsp;</span>
            </p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>四、</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>信息的存<span
            >儲</span>與保護</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>我們非常重視個人信息安全，故採取了必要合理且可行的措施來保護您的個人信息。</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l9 level1 lfo10'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>我們使用設在美國的谷歌雲數據託管服務來託管我們所收集到的信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l9 level1 lfo10'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>2、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>信息使用</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>TLS/SSL</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>技術加密，且您的賬戶受密碼保護，對您的個人信息訪問只限於在嚴格需要知道的基礎上的人員或服務商提供，他們只按照我們的指示處理您的信息，並對此負有保密責任。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l9 level1 lfo10'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>3、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>我們會定期審查我們的信息收集、存儲以及處理做法，以避免信息數據的損壞或丟失。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l9 level1 lfo10'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>4、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>雖然我們對您的信息採取了一系列的保障措施，但請注意，互聯網上的信息傳輸是不完全安全的，我們無法保證您的信息在通過互聯網傳輸的期間，或在存儲與我們的系統時是絕對安全可靠的，我們也建議您使用我們的產品和服務時，設置相對複雜的密碼，並注意保護您的個人信息安全。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l9 level1 lfo10'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>5、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>請您了解，上述所有的保護措施可能因不可能抗力或受限於技術限製，而不能絕對確保您的信息不會通過本協議中未列明的途徑洩露出去，對此我們不承擔上述非因我方過錯而導致的任何損失或責任。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>&nbsp;</span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>五、</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>您的<span
            >權</span>利</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>1、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>您有權利告知我們如何處理您的個人信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>2、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>要求我們提供持有的關於您的個人信息的副本。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>3、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>要求我們糾正持有的關於您的任何個人信息中任何不準確的地方。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>4、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>要求刪除您的個人信息（但請注意，這不包括您出於個人利益目的或是任何不符合法律法規而提出的刪除要求）。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>5、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>在我們依據您的同意來處理您的個人信息時，您可以隨時撤銷您的同意（但這不會影響在您撤銷同意之前我們所進行的任何處理的合法性）。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt;text-indent:0cm;mso-list:l5 level1 lfo11'><span
                style='
;mso-font-kerning:0pt;;mso-bidi-language:AR'><span style='mso-list:Ignore'>6、</span></span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>作為一項安全措施，我們可能需要您提供特定的信息，以幫助我們在處理您的隱私請求或行駛您的權利時確認您的身份。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>&nbsp;</span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>根據以上所述的您的合法權利條款中，我們原則上都會免費進行處理，但如果您的要求沒有根據、重複或是過度，我們對此可能會視情況收取合理的成本費用，請您知悉。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>另外，我們通常會在一個月內對所有的合理合法請求做出回應，但當您的請求特別複雜或是當您提出了多個請求時，我們的處理回復可能會需要超過一個月，請您諒解。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>&nbsp;</span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>六、</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>青少年的個人信息保護</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>1</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、我們非常重視對青少年的個人信息的保護，所以我們不會有意收集</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>16</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>周歲以下的人群個人信息。</span><span

                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>若我們意識到有</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>16</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>周歲以下的青少年向我們提供了個人信息，我們將採取措施刪除這些信息，如果您在使用過程中認為我們錯誤地或無意地收集了</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>16</span><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>周歲以下的青少年個人信息，請您盡快聯繫我們。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>2</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、若您是</span><span
                style='
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>16</span><span style='font-family:
"微軟正黑體",sans-serif;;background:white;
mso-font-kerning:0pt;mso-bidi-language:AR'>周歲以下的青少年用戶，在使用我們的服務前，請事先取得您家長或法定監護人的同意，我們將根據各項法律法規來保護您的個人信息安全。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>3</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、對於經父母或法定監護人同意而收集青少年個人信息的情況，我們只會在法律允許、父母或監護人明確同意，以及保護青少年所必要的情況下使用或公開披露此信息。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p><span style='
;
background:white;mso-font-kerning:0pt;mso-bidi-language:
AR'>&nbsp;</span></p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>七、</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>通知和修訂</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>1</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、為給您提供更好的服務以及隨著我司業務的發展，本隱私政策也會隨之更新，我&#20204;會通過在平台各終端上發出更新版本或以其他適當方式提醒您相關內容的更新，請您訪問平台時注意及時了解最新的隱私政策。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>2</span><span
                style='background:white;mso-font-kerning:0pt;;mso-bidi-language:AR'>、上述隱私政策的變更或更新將在發佈後即時生效。</span><span

                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>若您在該政策生效後繼續訪問平台或使用我們的服務，即表示您已充分閱讀、理解並接受我們修改更新後的隱私政策並受之約束。</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='margin-left:15.75pt'><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>&nbsp;</span>
            </p>

            <p style='margin-left:0cm;text-indent:0cm;mso-list:l2 level1 lfo3'><span
                style='
;mso-font-kerning:0pt;mso-bidi-language:
AR'><span style='mso-list:Ignore'>八、</span></span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>聯繫我們</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'></span></p>

            <p style='text-indent:21.0pt;mso-char-indent-count:2.0'><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>如果您有任何問題或<span>擔</span>憂，請在第一時間聯絡我們，也可以<span
            >將</span>您的任何<span>書</span>面請求提交至：</span><span
                style='
;background:white;mso-font-kerning:0pt;
mso-bidi-language:AR'>admin@shopopee.com</span><span
                style='background:white;mso-font-kerning:0pt;mso-bidi-language:AR'>。</span><span
                style='font-family:"Arial",sans-serif;
mso-fareast-font-family:sans-serif;background:white;mso-font-kerning:
0pt;mso-bidi-language:AR'></span></p>

        </div>

    </div>

</template>

<script setup>

</script>

<style scoped>

</style>